import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { TransferTokenService } from 'src/app/services/transfer-token.service';

@Component({
  selector: 'app-bam-taxes',
  templateUrl: './bam-taxes.component.html',
  styleUrls: ['./bam-taxes.component.scss']
})
export class BamTaxesComponent {
  accounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  accountOptions: AccountOptionResponse = null;

  user = null;
  company = null;

  amount: number = null;
  description: string = '';
  bankAccountNumberDebit: string = null;
  formNumber: string = '';
  contingencyNumber: string = '';

  confirmModalVisible = false;
  transferPreview: any = null;
  loading = false;

  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private accountService: AccountService,
    private bamTransferService: BamTransferServiceService,
    private transferTokenService: TransferTokenService
  ) {
    this.user = authService.getUser();
    this.company = JSON.parse(authService.getCurrentCompany());
  }

  ngOnInit(): void {
    this.getBanksOwn();
    this.getAccountOptions();
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data || [];
        this.filterAccountsDebit = this.accounts.filter(account => account.bank === 4);
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener las cuentas bancarias');
      }
    });
  }

  getAccountOptions() {
    this.accountService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener opciones de cuentas');
      }
    });
  }

  getBankName(idBank: number): string {
    if (!this.accountOptions || !this.accountOptions.erpBanks) return '';
    const bank = this.accountOptions.erpBanks.find(b => b.id === idBank);
    return bank ? bank.name : 'Banco desconocido';
  }

  openConfirmModal() {
    if (!this.bankAccountNumberDebit || !this.amount || this.amount <= 0 || !this.description || !this.formNumber) {
      this.toastService.error('Debes llenar los campos obligatorios antes de continuar');
      return;
    }

    const debitAccount = this.accounts.find(
      acc => String(acc.accountNumber) === String(this.bankAccountNumberDebit)
    );

    this.transferPreview = {
      amount: this.amount,
      description: this.description,
      formNumber: this.formNumber,
      contingencyNumber: this.contingencyNumber,
      debitAccount
    };

    this.confirmModalVisible = true;
  }

  onConfirmTransfer() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    this.confirmModalVisible = false;
    this.sendRequest();
  }

  onCancelTransfer() {
    this.confirmModalVisible = false;
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequest() {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    const request = {
      bankAccountNumberDebit: this.bankAccountNumberDebit,
      description: this.description,
      amount: this.amount,
      company: this.company.companyId,
      formNumber: this.formNumber,
      contingencyNumber: this.contingencyNumber ? this.contingencyNumber : null,
      token: this.code2fa
    };

    this.loading = true;

    this.bamTransferService.sendTaxPaymentTransfer(request).subscribe({
      next: (_response: any) => {
        if (_response.data.code != "OPERATION_SUCCESSFUL") {
          this.toastService.error(_response.data.message, _response.data.code);
          return;
        }
        this.toastService.success('Transferencia realizada correctamente');
        this.resetForm();
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al generar la transferencia', err);
        if (err.data.description) {
          this.toastService.error(err.data.description);
        } else {
          this.toastService.error('Error al generar la transferencia');
        }
        this.loading = false;
      }
    });
  }

  resetForm() {
    this.amount = null;
    this.description = '';
    this.bankAccountNumberDebit = null;
    this.formNumber = '';
    this.contingencyNumber = '';
    this.transferPreview = null;

    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequestCode() {
    this.loadingSendCode = true;
    
    this.transferTokenService.createTokenTransfer().subscribe({
      next: (_response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al solicitar token');
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }
}
